import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import { autoinject, bind, FormStore, inject, Input, Loader, Modal, ModalHandle, TasksStore } from 'Mri.Web.Common';
import * as React from 'react';
import { BsFileArrowDown } from '@react-icons/all-files/bs/BsFileArrowDown';
import { Button, Form, FormGroup } from 'reactstrap';
import { ContractsStore } from './ContractsStore';

export interface ICreateDisplayGroupModalProps {
    readonly history: any;
    readonly modalHandle: ModalHandle;
}

@autoinject
@observer
export class ImportContractModal extends React.Component<ICreateDisplayGroupModalProps> {
    public render() {
        return (
            <Modal title={this.title} modalHandle={this.props.modalHandle} footer={this.footer} bodyClass="p-0">
                {!!this.contractForm.globalErrors.length && (
                    <div className="alert-danger p-2">
                        <ul>
                            {this.contractForm.globalErrors.map((e, idx) => (
                                <li key={idx}>{e}</li>
                            ))}
                        </ul>
                    </div>
                )}

                <div className="p-3">
                    <Form>
                        <FormGroup color={this.contractForm.fields.serviceCO.state}>
                            <label>Number</label>

                            <Input type="text" id="name" field={this.contractForm.fields.serviceCO} required />
                        </FormGroup>
                    </Form>
                </div>
            </Modal>
        );
    }

    //Private Functions
    @bind
    @action
    private async submitAsync(event: React.MouseEvent<HTMLButtonElement>) {
        event.preventDefault();

        this.contractForm.onSubmit();
        if (this.contractForm.validate()) {
            const serviceCO = this.contractForm.values.serviceCO;
            this.loading = true;
            const task = this.tasksStore.startSessionTask(`Import Contract ${serviceCO}`);

            try {
                await this.contractsStore.importAsync(this.contractForm.values);
                task.complete();
                const contract = this.contractsStore.contracts.get(serviceCO);
                this.props.modalHandle.close();
                this.contractForm.clear();
                if (contract) {
                    this.props.history.push(
                        `/accounts/${contract.accountNumber}/contracts/${contract.serviceCO}/manage`
                    );
                }
            } catch (e: any) {
                if (e.modelState) {
                    this.contractForm.clearGlobalErrors();
                    this.contractForm.addErrors(e.modelState);
                } else {
                    task.error(e);
                }
            } finally {
                this.loading = false;
            }
        } else {
            console.error('The Form is invalid');
        }
    }

    //Private Fields
    private title = (
        <span className="text-header fw-bold">
            <BsFileArrowDown /> Import Contract
        </span>
    );

    @computed
    private get footer() {
        return (
            <Button color="primary" onClick={this.submitAsync} disabled={this.loading}>
                <Loader loading={this.loading} showSpinner message="Importing Contract..." />
                {!this.loading && 'Import Contract'}
            </Button>
        );
    }

    @observable
    private loading = false;

    private readonly contractForm = new FormStore<Mri.Web.Internal.Controllers.Contracts.ImportContractModel>({
        serviceCO: '',
    });
    @inject
    private contractsStore!: ContractsStore;
    @inject
    private tasksStore!: TasksStore;
}
